import React, { useState } from 'react';
import '../css/components/CompanyLogo.css';

interface CompanyLogoProps {
    domain: string;
    name: string;
    size?: number;
}

// Was Clearbit's logo API (logo.clearbit.com) — confirmed dead (NXDOMAIN,
// likely decommissioned post-HubSpot acquisition), not just rate-limited.
// Switched to Google's favicon service, same free/no-key mechanism, just
// pulling the site's actual favicon instead of a curated logo asset — lower
// resolution on some sites, but reliable and this is genuinely how most
// "show a company logo from its domain" products get this data; it's a
// favicon lookup, not proprietary brand data. Falls back to a colored
// initial badge if a request ever truly errors.
const CompanyLogo: React.FC<CompanyLogoProps> = ({ domain, name, size = 32 }) => {
    const [failed, setFailed] = useState(false);
    const cleanDomain = (domain || '').trim().toLowerCase();

    if (!cleanDomain || failed) {
        const initial = (name || '?').trim().charAt(0).toUpperCase();
        return (
            <span
                className="company-logo company-logo--fallback"
                style={{ width: size, height: size, fontSize: size * 0.45 }}
                aria-hidden="true"
            >
                {initial}
            </span>
        );
    }

    return (
        <img
            className="company-logo"
            style={{ width: size, height: size }}
            src={`https://www.google.com/s2/favicons?domain=${cleanDomain}&sz=${size * 2}`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            onError={() => setFailed(true)}
        />
    );
};

export default CompanyLogo;
